import {useState} from "react";
import {useGetReviews} from "../../../react-query-hooks/reviews/get-reviews";
import {FullPageLoader} from "../../full-page-loader";
import {Alert, Space} from "antd";
import {EmptyState} from "../../empty-state";
import {ReviewsFilter} from "../filter";
import {ReviewsExportCsv} from "../export-csv";
import {ReviewsTable} from "../table";
import {AverageRatingsSection} from "../average-ratings";
import {CustomPagination} from "../../pagination";

export function ReviewsPageDisplay() {
  const [page, setPage] = useState(1);
  const getReviewsQuery = useGetReviews(page);

  if (getReviewsQuery.isLoading) {
    return <FullPageLoader />;
  }

  if (getReviewsQuery.isError) {
    return (
      <Alert
        message="Error"
        description={getReviewsQuery.error.message}
        type="error"
        showIcon
      />
    );
  }
  const isExportCsvDisabled = getReviewsQuery.data.data.ratingsAndReviews.length < 1;
  return (
    <div>
      {getReviewsQuery.data.data.ratingsAndReviews.length < 1 ? (
        <EmptyState message="You do not have any reviews at the moment." />
      ) : (
        <Space size={24} direction="vertical" style={{display: "flex"}}>
          {/* <ReviewsFilter /> */}
          <ReviewsExportCsv isExportCsvDisabled={isExportCsvDisabled} />
          <div>
            <ReviewsTable reviews={getReviewsQuery.data.data.ratingsAndReviews} />
            <CustomPagination
              isPreviousData={getReviewsQuery.isPreviousData}
              page={page}
              paginationMeta={getReviewsQuery.data.meta}
              setPage={setPage}
            />
          </div>
          <AverageRatingsSection />
        </Space>
      )}
    </div>
  );
}
